import type {StateProvider} from '@uirouter/angularjs';
import FavouritesController from './favourites.controller';
import type {FavouritesCollectionService} from './favourites-collection.service';
import type {RecordCollectionsDataService} from '../../record-collections/record-collections.data-service';

/*@ngInject*/
export default function favouritesRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state({
            name: 'favourites',
            url: '/favourites',
            templateUrl: require('./favourites.tpl.ftl'),
            controller: FavouritesController,
            controllerAs: '$ctrl',
            resolve: {
                /*@ngInject*/
                viewConfiguration: (favouritesCollectionService: FavouritesCollectionService, recordCollectionsDataService: RecordCollectionsDataService) => FavouritesController.getConfiguration(favouritesCollectionService, recordCollectionsDataService),

                /*@ngInject*/
                recordCollectionManager: (favouritesCollectionService: FavouritesCollectionService) => FavouritesController.preloadFavouritesCollectionManager(favouritesCollectionService)
            }
        });
}
